import React from 'react';

type MoneyProps = {
  value: number | string;
  showDollarSign?: boolean;
  showComma?: boolean;
};

export const formatMoney = (
  value?: number | string | null,
  showDollarSign: boolean = true,
  showComma: boolean = true,
  showDecimals: boolean = true
) => {
  const disallowedValues = [NaN, null, undefined, ''];
  if (disallowedValues.includes(value)) return null;

  const numericValue = typeof value === 'string' ? parseFloat(value) : value;

  let formattedValue = (numericValue as number).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  if (!showDollarSign) {
    formattedValue = formattedValue.replace('$', '');
  }

  if (!showComma) {
    formattedValue = formattedValue.replace(/,/g, '');
  }

  if (!showDecimals) {
    formattedValue = formattedValue.replace(/\.\d{2}/, '');
  }

  return formattedValue;
};

export const Money: React.FC<MoneyProps> = ({
  value,
  showDollarSign = true,
  showComma = true,
}) => {
  const formattedValue = formatMoney(value, showDollarSign, showComma);
  return <span>{formattedValue}</span>;
};

export default Money;
